export const LogoMark = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 34L21 8L36 34"
      stroke="#D97736"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 34L21 19L29 34"
      stroke="#F3F4F6"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="6" y1="34" x2="36" y2="34" stroke="#D97736" strokeWidth="2" strokeOpacity="0.4" />
  </svg>
);

export const BrandLockup = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-syne font-bold text-lg tracking-tight text-[#F3F4F6]">MERLO</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.35em] text-[#D97736]">coperture</span>
    </span>
  </span>
);
